export function handleAdminQuantityDefinitionCategoryUpdated(state, payload) {
    const { category } = payload;
    console.log('so updated category is: ', category)
    if (!category?.id) return state;
    const existing = state.categoriesById[category.id];
    if (!existing) return state;

    const updatedCategory = {
        ...existing,
        title: category.title ?? existing.title,
        isActive: category.is_active ?? existing.is_active,
    };

    const nodeId = `c${category.id}`;
    console.log('state.categoriesById: ', state.categoriesById)

    console.log('state.categoriesById: ', state.categoriesById[category.id])
    return {
        ...state,
        categoriesById: {
            ...state.categoriesById,
            [category.id]: updatedCategory,
        },
    };
}